@if (gotDgProperties) {
  <app-grid-view #gridView
    [apiPath]="dgApiPath"
    [dgActionColumn]="dgActionColumn"
    [dgColumns]="dgColumns"
    [dgPopup]="dgPopup"
    [dgProperties]="dgProperties"
    (rowClick)="_gridRowClick($event)"
    (rowDblClick)="_gridRowDblClick($event)"
  >
  </app-grid-view>
}
